const PaymentNotification = () => {
  return (
    <div>
      <h2>Payment Notification Received</h2>
      <p>Processing the payment status...</p>
    </div>
  );
};

export default PaymentNotification;
